export const dialogTitle = (type, titleDict) => {
  return titleDict[type]
}
